<div class="position-relative" >
  <span mat-dialog-close="" class="dialog-close" *ngIf="disableClose">
    <img [src]="'assets/icons/close-modal.svg'" />
  </span>
  <div class="text-center mt-8" *ngIf="icon">
    <img class="alert-icon" [src]="icon" alt="alert icon" />
  </div>
  <strong style="margin-left: 6px;" class="fs-20" mat-dialog-title>{{ title }}</strong>
  <p class="fs-20" class="dialog-description">
    {{ message }}
  </p>
  <div class="d-flex justify-content-end p-3">
    <app-button
      mat-dialog-close=""
      [stroked]="true"
      color="primary"
      innerClass="mx-2"
      text="{{ cancelBtn }}"
      *ngIf="cancelBtn"
    ></app-button>
    <app-button
      color="primary"
      text="{{ confirmBtn }}"
      *ngIf="confirmBtn"
      (click)="onDialogClose()"
    ></app-button>
  </div>
</div>
